export default __webpack_public_path__ + "static/casestudy_2-aa2a00695044e922f3267e6782bbef81.png";